import { render, staticRenderFns } from "./AssetType.vue?vue&type=template&id=19c7c9c8&scoped=true"
import script from "./AssetType.vue?vue&type=script&lang=js"
export * from "./AssetType.vue?vue&type=script&lang=js"
import style0 from "./AssetType.vue?vue&type=style&index=0&id=19c7c9c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7c9c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c7c9c8')) {
      api.createRecord('19c7c9c8', component.options)
    } else {
      api.reload('19c7c9c8', component.options)
    }
    module.hot.accept("./AssetType.vue?vue&type=template&id=19c7c9c8&scoped=true", function () {
      api.rerender('19c7c9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset/AssetType/AssetType.vue"
export default component.exports